<template>
  <v-container id="totems" tag="section">
    <base-v-component heading="Totems del Negocio " />
    <base-material-card color="indigo" icon="mdi-laptop" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{formTitle}}</v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row v-if="isEdit">
                  <v-col sm12>
                    <v-text-field v-model="id" label="Codigo" disabled></v-text-field>
                  </v-col>
                </v-row>
                <v-row wrap>
                  <v-col xs12 sm6>
                    <v-text-field
                      v-model="nombre"
                      label="Nombre"
                      :error-messages="nombreErrors"
                      messages="Sin relevancia"
                    ></v-text-field>
                  </v-col>
                  <v-col xs12 sm5>
                    <v-select :items="restaurantesSelect" v-model="restaurante" label="Restaurante"></v-select>
                  </v-col>
                  <v-col xs12 sm1>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn text @click="copiarDatosRest" v-on="on">
                          <v-icon>mdi-reload</v-icon>
                        </v-btn>
                      </template>
                      <span>Copiar datos sincronización desde el restaurante</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="url"
                      label="Url"
                      :append-icon="showUrl ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showUrl ? 'text' : 'password'"
                      @click:append="showUrl = !showUrl"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="centro"
                      label="centro"
                      :append-icon="showCentro ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showCentro ? 'text' : 'password'"
                      @click:append="showCentro = !showCentro"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="apikey"
                      label="Api Key"
                      :append-icon="showApikey ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showApikey ? 'text' : 'password'"
                      @click:append="showApikey = !showApikey"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-file-input
                      v-if="!imagenFondoSrc"
                      accept="image/*"
                      label="Imagen Fondo"
                      v-model="imagenFondo"
                    ></v-file-input>
                    <template v-else>
                      <v-col cols="4">
                        <v-img :src="imagenFondoSrc" width="65px"></v-img>
                      </v-col>
                      <v-col cols="4">
                        <v-btn text @click="imagenFondoSrc = null">Cambiar Imagen</v-btn>
                      </v-col>
                    </template>
                  </v-col>
                  <v-col cols="6">
                    <v-file-input
                      v-if="!imagenLogoSrc"
                      accept="image/*"
                      label="Imagen Logo"
                      v-model="imagenLogo"
                    ></v-file-input>
                    <template v-else>
                      <v-col cols="4">
                        <v-img :src="imagenLogoSrc" width="65px"></v-img>
                      </v-col>
                      <v-col cols="4">
                        <v-btn text @click="imagenLogoSrc = null">Cambiar Imagen</v-btn>
                      </v-col>
                    </template>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-select
                      v-model="formasPagoModel"
                      :items="formasPago"
                      label="Formas de Pago"
                      multiple
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="formasServicioModel"
                      :items="formasServicio"
                      label="Formas de Servicio"
                      multiple
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="loadingForm">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="printersDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">IMPRESORAS DEL TOTEM</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-autocomplete
                  v-model="impresoraTotem"
                  :items="impresoras"
                  :loading="isLoadingSelect"
                  :search-input.sync="searchImp"
                  color="white"
                  hide-no-data
                  hide-selected
                  item-text="mostrarSelect"
                  item-value="id"
                  label="Impresoras"
                  placeholder="Busca"
                  prepend-icon="mdi-database-search"
                  return-object
                ></v-autocomplete>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="saveImpresoras"
                :loading="loadingImpresoras"
              >Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table :headers="headers" :items="totems" :loading="loading" :search="search">
        <template v-slot:item.acciones="{ item }">
          <v-row class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-switch
              class="pa-0 ma-0 mr-3"
              v-model="item.activo"
              :loading="item.loadingActivo"
              @change="changeActivo(item)"
            ></v-switch>
            <v-btn class="px-2 ml-1" color="success" min-width="0" small>
              <v-icon small @click="editItemDialog(item)">mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="px-2 ml-1" color="success" min-width="0" small>
              <v-icon small @click="openImpresoras(item)">mdi-printer</v-icon>
            </v-btn>
            <v-btn class="px-2 ml-1" color="red" min-width="0" small>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>


<script>
import { createSlug } from "@/utils/utils.js";
import { mapState, mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  validations: {
    nombre: { required, minLength: minLength(4) }
  },
  data() {
    return {
      loading: false,
      loadingForm: false,
      dialog: false,
      search: "",
      id: null,
      nombre: "",
      url: "",
      centro: "",
      apikey: "",
      restaurante: "",
      imagenFondo: null,
      imagenFondoSrc: null,
      imagenLogo: null,
      imagenLogoSrc: null,
      formasPagoModel: [],
      formasServicioModel: [],
      loadingActivo: false,
      showApikey: false,
      showCentro: false,
      showUrl: false,
      printersDialog: false,
      loadingImpresoras: false,
      impresoraTotem: false,
      isLoadingSelect: false,
      searchImp: "",
      itemEditandoImpresoras: null,
      headers: [
        {
          sortable: false,
          text: "Estado",
          value: "estado"
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre"
        },
        {
          sortable: false,
          text: "Restaurante",
          value: "restaurante"
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right"
        }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.isEdit ? "Editar Totem" : "Nuevo Totem";
    },
    ...mapState({
      idiomas: "idiomas",
      langDefecto: "langDefecto",
      totems: state => state.totems.totemsArray,
      formasPago: state => state.totems.formasPago,
      formasServicio: state => state.totems.formasServicio
    }),
    ...mapGetters({
      negocio: "app/negocioGestObj",
      restaurantes: "restaurantes/getRestaurantesListado",
      restaurantesSelect: "restaurantes/getRestaurantesSelect",
      impresoras: "negocios/getSelectImpresoras"
    }),
    subtitle() {
      return "Listado de totems de " + this.negocio.nombre;
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio");
      return errors;
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  methods: {
    copiarDatosRest() {
      alert("Aqui copiará los datos de mapeo desde el restaurante");
    },
    openImpresoras(item) {
      let _vm = this;
      this.impresoraTotem = item.impresora;
      this.itemEditandoImpresoras = item;
      this.$store
        .dispatch("negocios/getImpresorasNegocio")
        .then(() => {
          this.printersDialog = true;
        })
        .catch(e => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error: " + e
          });
        });
    },
    saveImpresoras() {
      let _vm = this;
      let payload = {
        item: this.itemEditandoImpresoras,
        impresora: this.impresoraTotem
      };
      this.$store
        .dispatch("totems/addImpresoraTotem", payload)
        .then(res => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Impresora grabada con éxito"
          });
          _vm.getTotems();
          _vm.printersDialog = false;
        })
        .catch(error => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la impresora: " + error
          });
        });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      this.nombre = "";
      this.restaurante = "";
      this.apikey = "";
      this.id = null;
      this.centro = "";
      (this.url = ""),
        (this.imagenFondo = null),
        (this.imagenFondoSrc = null),
        (this.imagenLogo = null),
        (this.imagenLogoSrc = null);
    },
    reload() {
      this.getTotems();
    },
    editItemDialog(item) {
      this.nombre = item.nombre;
      this.restaurante = item.restaurante;
      this.apikey = item.apikey;
      this.id = item.id;
      (this.centro = item.centro), (this.url = item.url);
      (this.dialog = true), (this.imagenFondoSrc = item.imagenFondo);
      this.imagenLogoSrc = item.imagenLogo;
      this.formasServicioModel = item.formasServicio;
      this.formasPagoModel = item.formasPago;
    },
    addTotem() {
      let t = {
        nombre: this.nombre,
        restaurante: this.restaurante,
        apikey: this.apikey,
        centro: this.centro,
        url: this.url,
        id: this.id,
        imagenFondo: this.imagenFondo,
        imagenLogo: this.imagenLogo,
        formasPago: this.formasPagoModel,
        formasServicio: this.formasServicioModel
      };
      return this.$store.dispatch("totems/addTotem", t);
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addTotem()
            .then(res => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Totem grabado con éxito"
              });
              _vm.getTotems();
              _vm.dialog = false;
            })
            .catch(error => {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar el tótem: " + error
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
    getTotems() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("totems/getTotems").finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el totem? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("totems/deleteTotem", item)
          .then(res => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Totem eliminado"
            });
            _vm.getTotems();
          })
          .catch(error => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar: " + error
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    initNegocio() {
      //let negocio = this.$route.params.negocio;
      //this.$store.commit('app/setNegocioGest', negocio, { root: true });
    },
    changeActivo(item) {
      item.loadingActivo = true;
      let _vm = this;
      this.$store
        .dispatch("totems/changeActivoTotem", item)
        .then(res => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Cambiado estado totem"
          });
        })
        .catch(error => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al cambiar el estado del tótem: " + error
          });
        })
        .finally(() => {
          item.loadingActivo = false;
        });
    }
  },
  mounted() {
    let _vm = this;
  }
};
</script>

<style>
</style>